// eslint-disable-next-line no-use-before-define
import { Form, Field, Formik, FormikProps, FormikValues } from 'formik';
import { FormContainer } from 'op-components';
import { RegistrationContext } from 'op-contexts';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { FormRow } from 'shared-components/components';
import {
  CONTINUE_BUTTON_TEXT,
  HeaderSubTitle,
  HeaderTitle,
  linkedField,
  registrationPath,
  RETURN_TO_SUBMIT_TEXT,
  sharedFormContainerProps,
  standardField,
  StyledHorizontalLine,
  isFormValid,
} from '../Helper';
import { PatientContactRego, RegistrationFormUSIProps } from '../interfaces';
import { CONTACT_FIELDS } from './constants';

import { generateValidationSchema } from './validation';

interface ContactDetailsFormIProps extends RegistrationFormUSIProps {
  patient: PatientContactRego;
}

const ContactDetailsForm = (props: ContactDetailsFormIProps): JSX.Element => {
  const registrationContext = useContext(RegistrationContext);
  const { updateField, patient, handleShowSaveExitConfirm, previousPageLink } = props;
  const history = useHistory();
  const goToSummary = registrationContext?.registrationSummaryVisited;
  // setFieldTouched,
  return (
    <Formik
      initialValues={patient}
      validate={(values: FormikValues) => generateValidationSchema(values)}
      validateOnChange={true}
      validateOnBlur
      onSubmit={() => history.push(registrationPath(patient?.id, goToSummary ? 'summary' : 'address'))}>
      {({ submitForm, setTouched, errors, touched }: FormikProps<PatientContactRego>) => {
        const sharedProps = sharedFormContainerProps('Contact Details', 2, previousPageLink);
        const formContainerProps = {
          ...sharedProps,
          submitButtonText: goToSummary ? RETURN_TO_SUBMIT_TEXT : CONTINUE_BUTTON_TEXT,
          continueDisabled: isFormValid(errors, touched),
          handleShowSaveExitConfirm,
        };

        return (
          <FormContainer
            {...formContainerProps}
            submitForm={submitForm}
            handleValidation={(event: React.MouseEvent<HTMLInputElement>): void => {
              void event;
            }}>
            <Form>
              <HeaderTitle data-test-id="rego-page-title">{CONTACT_FIELDS.FORM_HEADING.TITLE}</HeaderTitle>
              <HeaderSubTitle>* = required field</HeaderSubTitle>
              {linkedField(CONTACT_FIELDS.MOBILE, CONTACT_FIELDS.HOME_PHONE, updateField)}
              <FormRow labelClass={'label-form-row'}>
                <StyledHorizontalLine>
                  <span>OR</span>
                </StyledHorizontalLine>
              </FormRow>
              {linkedField(CONTACT_FIELDS.HOME_PHONE, CONTACT_FIELDS.MOBILE, updateField)}
              {standardField(CONTACT_FIELDS.EMAIL, updateField)}
            </Form>
          </FormContainer>
        );
      }}
    </Formik>
  );
};

export default ContactDetailsForm;
